import { render, staticRenderFns } from "./RouteGroup.vue?vue&type=template&id=04f9d0bd&scoped=true&"
import script from "./RouteGroup.vue?vue&type=script&lang=js&"
export * from "./RouteGroup.vue?vue&type=script&lang=js&"
import style0 from "./RouteGroup.vue?vue&type=style&index=0&id=04f9d0bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f9d0bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VTooltip})
